// src/services/twoFactorAuthService.ts
import { AxiosResponse } from 'axios';
import apiClient from './apiClient';

/**
 * 2FA 有効化用：TOTP のプロビジョニング URI を取得する API
 * GET: /2fa/enable/
 */
export const getEnable2FA = async (): Promise<AxiosResponse> => {
  return apiClient.get('/users/2fa/enable/');
};

/**
 * 2FA の有効化（TOTPコード検証） API
 * POST: /2fa/enable/
 * @param code TOTPコード
 */
export const enable2FA = async (code: string): Promise<AxiosResponse> => {
  return apiClient.post('/users/2fa/enable/', { code });
};

/**
 * 2FA の無効化 API
 * POST: /2fa/disable/
 * @param code 任意：TOTPコード（必要な場合のみ）
 */
export const disable2FA = async (code?: string): Promise<AxiosResponse> => {
  return apiClient.post('/users/2fa/disable/', { code });
};

/**
 * バックアップコード再生成 API
 * POST: /2fa/backup-codes/
 */
export const regenerateBackupCodes = async (): Promise<AxiosResponse> => {
  return apiClient.post('/users/2fa/backup-codes/', {});
};

/**
 * 2FAリセット用メールリンク送信
 * POST: /users/2fa/recovery/request/
 */
export const request2FARecovery = async (
  email: string
): Promise<AxiosResponse> =>
  apiClient.post('/users/2fa/recovery/request/', { email });

interface RecoverPayload {
  email?: string;
  backup_code?: string;
  token?: string;
}

/**
 * 2FAリセット確定（メールリンク or バックアップコード）
 */
export const confirm2FARecovery = (
  payload: RecoverPayload
): Promise<AxiosResponse> => {
  return apiClient.post('/users/2fa/recovery/confirm/', payload);
};
